export default __webpack_public_path__ + "static/media/talent_main-section-Fill-Dev-IT.bb21aeef.svg";